import React from 'react';
import ProgressTracker, { ProgressStep, ProgressTrackerOrientation } from './ProgressTracker';
import '../../styles/StatusTracker.css';

const steps: ProgressStep[] = [
  { id: 1, label: 'Application Submitted' },
  { id: 2, label: 'Under Review' },
  { id: 3, label: 'Decision' },
];

interface StatusTrackerProps {
  status: 'pending' | 'approved' | 'rejected' | 'withdrawn';
}

const StatusTracker: React.FC<StatusTrackerProps> = ({ status }) => {
  // Map status to step index (1-based)
  // For 'pending', highlight Under Review (2), mark Submitted as completed
  // For 'approved' or 'rejected', highlight last step
  let currentStep = 2;
  if (status === 'approved') currentStep = steps.length + 1; // all completed
  if (status === 'rejected') currentStep = 3;
  if (status === 'withdrawn') currentStep = 3;
  if (status === 'pending') currentStep = 2;
  const orientation: ProgressTrackerOrientation = 'horizontal';

  const isRejected = status === 'rejected';
  const isWithdrawn = status === 'withdrawn';
  const isApproved = status === 'approved';
  return (
    <div className="status-tracker-container">
      <div className="status-tracker-header">
        <h1 className="status-tracker-title">
          {isRejected ? 'Application Rejected' : isWithdrawn ? 'Application Withdrawn' : isApproved ? 'Application Approved' : 'Application Progress'}
        </h1>
      </div>
      <ProgressTracker
        steps={steps}
        currentStep={currentStep}
        orientation={orientation}
        rejected={isRejected}
        withdrawn={isWithdrawn}
        approved={isApproved}
      />
    </div>
  );
}

export default StatusTracker;
